import { c as _c } from "react/compiler-runtime";
import { useEventListener } from 'usehooks-ts';
import { create } from 'zustand';
const useStore = create<{
  isVisible: boolean;
}>(() => ({
  isVisible: false
}));
const useAiImageScoresVisible = hasScores => {
  const $ = _c(2);
  let t0;
  if ($[0] !== hasScores) {
    t0 = event => {
      if (!hasScores || !event.metaKey || !event.shiftKey || event.key.toLowerCase() !== "j") {
        return;
      }
      event.preventDefault();
      useStore.setState(_temp);
    };
    $[0] = hasScores;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEventListener("keydown", t0);
  return useStore(_temp2);
};
export const setAiImageScoresVisible = (isVisible: boolean) => useStore.setState({
  isVisible
});
export default useAiImageScoresVisible;
function _temp(state) {
  return {
    isVisible: !state.isVisible
  };
}
function _temp2(state_0) {
  return state_0.isVisible;
}